import { helpCenterService } from '../../common/services/helpCenter';
import { homepageService } from '../../common/services/homepage/homepageService';

interface TestVersionPayload {
  ab_test_version:
    | 'full_page'
    | 'full_page_w_kb'
    | 'widget'
    | 'homepage_widget';
}

export function getTestVersionPayload(): TestVersionPayload {
  if (homepageService.homepageEnabled) {
    return {
      ab_test_version: helpCenterService.isFullWidth
        ? 'full_page_w_kb'
        : 'homepage_widget',
    };
  } else {
    return {
      ab_test_version: helpCenterService.isFullWidth ? 'full_page' : 'widget',
    };
  }
}
